export const enum DrawerStatus {
  Showed = 'SHOWED',
  Hidden = 'HIDDEN',
}
